import React, { Component, PropTypes } from 'react'
import BreadcrumbProgress from '../breadcrumb-progress'

export const BREADCRUMB_BASIC_DETAILS = 'basicDetails'
export const BREADCRUMB_TICKETS = "Tickets"
export const BREADCRUMB_SALES_DATES = "Sales Dates"
export const BREADCRUMB_MORE_DETAILS = "Details"
export const BREADCRUMB_VOUCHERS = "Vouchers"
export const BREADCRUMB_REVIEW = "Review"

const EVENT_STEPS = [
  { key: BREADCRUMB_BASIC_DETAILS, value: 'Event' },
  BREADCRUMB_TICKETS,
  BREADCRUMB_SALES_DATES,
  BREADCRUMB_MORE_DETAILS,
  BREADCRUMB_REVIEW
]
const VOUCHER_STEPS = [{ key: BREADCRUMB_BASIC_DETAILS, value: 'Product' }, BREADCRUMB_VOUCHERS, BREADCRUMB_REVIEW]

class SetupformBreadcrumbProgress extends Component {
  getSteps() {
    return this.props.isVoucher
      ? VOUCHER_STEPS
      : EVENT_STEPS
  }

  getStepIndex(steps) {
    return steps.findIndex(step => step === this.props.currentStep || step.key === this.props.currentStep)
  }

  render() {
    const steps = this.getSteps()
    const stepLabels = steps.map(step => step.value || step)
    return <BreadcrumbProgress items={stepLabels} step={this.getStepIndex(steps)} />
  }
}

SetupformBreadcrumbProgress.propTypes = {
  currentStep: PropTypes.string,
  isVoucher: PropTypes.bool,
}

export default SetupformBreadcrumbProgress



/** WEBPACK FOOTER **
 ** ./src/components/setupform-breadcrumb-progress/index.js
 **/